import { getURLSearchParams } from "@/utils";
import { useContext } from "react";
import { useStore } from "zustand";
import { URL_SEARCH_PARAM } from "../constants";
import type {
	ActiveFilters,
	InitialStateArgs,
	StoreActions,
	StoreState,
} from "../types";
import Context from "./context";

export function useExplorerStore<T>(
	selector: (store: StoreState & StoreActions) => T,
): T {
	const store = useContext(Context);
	if (!store) throw new Error("Store not found");
	return useStore(store, selector);
}

export function useInitialStateFromURLParams({
	filters,
}: InitialStateArgs): Partial<StoreState> {
	const url = new URL(window.location.href);
	const search = getURLSearchParams([URL_SEARCH_PARAM]);
	const activeFilters = filters ? getURLSearchParams(filters) : {};
	return {
		activeFilters,
		activeSearch: search[URL_SEARCH_PARAM]?.at(0),
	};
}
